import { render, staticRenderFns } from "./Voteslider.vue?vue&type=template&id=4ce45fb1&scoped=true&"
import script from "./Voteslider.vue?vue&type=script&lang=js&"
export * from "./Voteslider.vue?vue&type=script&lang=js&"
import style0 from "./Voteslider.vue?vue&type=style&index=0&id=4ce45fb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce45fb1",
  null
  
)

export default component.exports